import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungEssen() {
  return (
    <CityPageTemplate
      city="Essen"
      slug="essen"
      intro="Essen im Wandel – nutze die Chancen der neuen Wirtschaftsstruktur für Deinen persönlichen Vermögensaufbau."
      description="Unabhängige & digitale Finanzberatung für Essen: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
